/* eslint-disable react/jsx-indent */
import React, { useState } from 'react';
import { Select, Form, Popover } from 'antd';

const FilterSelect = (
  {
    children,
    className,
    data,
    initialValue,
    isLast,
    name,
    multiple,
    placeholder,
    showSearch,
    label,
    width,
    disabled,
    allowClear,
    hidden,
    ...rest
  },
  ref
) => {
  const [visible, setVisible] = useState({ popover: false, select: false });

  const handleVisiblePopover = (value) => {
    setVisible({ ...visible, popover: visible.select ? false : value });
  };

  const handleVisibleSelect = (value) => {
    setVisible({ select: value, popover: false });
  };

  const getPlaceholder = (values) => {
    if (values.length <= 0) {
      return '';
    }

    if (values.length === 1) {
      return values[0].label;
    }

    return (
      <Popover
        title={placeholder}
        visible={visible.popover}
        onVisibleChange={handleVisiblePopover}
        placement="bottomLeft"
        content={
          <div>
            {values.map((c) => (
              <div key={c.key} className="gx-mb-1">
                {c.label}
              </div>
            ))}
          </div>
        }
      >
        {`${values.length} selecionados`}
      </Popover>
    );
  };

  return (
    <Form.Item
      name={name}
      noStyle={!label}
      initialValue={initialValue}
      label={label}
      className={className}
      hidden={hidden}
    >
      <Select
        ref={ref}
        className={isLast ? '' : 'gx-mr-1  height-fixed'}
        showArrow
        showSearch={showSearch ?? false}
        placeholder={placeholder}
        style={{ width: width ?? '100%' }}
        maxTagPlaceholder={getPlaceholder}
        dropdownMatchSelectWidth={false}
        onDropdownVisibleChange={handleVisibleSelect}
        maxTagCount={0}
        disabled={disabled}
        allowClear={allowClear}
        {...rest}
      >
        {data
          ? data.map((c) => (
              <Select.Option key={c.key} value={c.key}>
                {c.label}
              </Select.Option>
            ))
          : children}
      </Select>
    </Form.Item>
  );
};

export default React.forwardRef(FilterSelect);
